import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { isResourceAutoOpenLaunch } from "./lib/mode";
import { applyThemeFromTelegram } from "./lib/tg";
import App from "./App";
import "./index.css";

applyThemeFromTelegram();

if (isResourceAutoOpenLaunch()) {
  document.documentElement.dataset.tpAutoOpen = "true";
}

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
